import { useTranslation } from 'react-i18next';
export function useTranslationUser() {
    const { t } = useTranslation('user');
    return { tuser: t };
}
